import { Link } from "gatsby";
import React from "react";
import { Container } from "reactstrap";

export interface TopStripPromotionProps {
  display: boolean;
  innerRef: any;
  sticky: boolean;
}

export const TopStripPromotion: React.FunctionComponent<TopStripPromotionProps> = (props: TopStripPromotionProps) => {
  return (
    <>
      <div
        ref={props.innerRef}
        className={`top-strip text-center ${props.display === true ? "open" : "closed"} ${
          props.sticky === true ? "" : "fixed"
        }`}
      >
        <Container>
          <div className="promotion d-none d-md-inline">
            <Link to="/education/ethics-course-bundle/">
              <span className="underline fw400">InnerEthics® Level 1 Certification</span>{" "}
              <span className="fw600">- 6 Course Bundle</span>
            </Link>
          </div>
          <div className="promotion d-inline d-md-none">
            <Link to="/education/ethics-course-bundle/">
              <span className="underline fw400">InnerEthics® Level 1 Certification</span>{" "}
              <span className="fw600">- 6 Course Bundle</span>
            </Link>
          </div>
        </Container>
      </div>
    </>
  );
};
